import { createStore, applyMiddleware, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import rootReducer from "./reducers";
import rootEpic from "./epics";

/*
import { Iterable } from "immutable";
import { createLogger } from "redux-logger";*/

/*
const stateTransformer = state => {
  let newState = {};

  for (var i of Object.keys(state)) {
    if (Iterable.isIterable(state[i])) {
      newState[i] = state[i].toJS();
    } else {
      newState[i] = state[i];
    }
  }

  return newState;
};

const logger = createLogger({
  stateTransformer
});*/

const epicMiddleware = createEpicMiddleware();

export default function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(/*logger,*/ epicMiddleware),
    )
  );

  epicMiddleware.run(rootEpic);

  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js